import React from 'react'; 
import './Magnificent.css'; 

import '../../Button.css'; 

function MagnificentMandarin() {
  window.scrollTo(0, 0);
    return (
      <>
           
          <div className="Magnificent"> 

          <form method="get" action="#/magnificent"> 
            <button id="the-button" type='btn'>English</button> 
          </form> 

            <h1 className="exhibition">重现600年前金碧辉煌的壁画⻛采</h1> 
              <hr /> 

              <h5 id="caption">
              2016年6月26日-7月3日  
            </h5> 

            <img id="image-thing-m" src="M1.jpg" /> 

            <h1 id="big-name">
            高级策展人：刘丽娜 (Lena Liu)  
            </h1> 

            <h1 id="ndot"> 
            法海禅寺壁画的收藏与鉴赏 
            </h1> 

            <p id="art-paragraph-other">
            法海禅寺壁画的收藏与鉴赏—在日本东京的亿万富翁软银集团CEO 孙正义的俱乐部开幕 (孙正义是阿里巴巴的投资者) 日本的艺术展取得了巨大的成功，
            日本的博物馆，艺术院校和画廊都迫不及待预约 下一届展览。 日本⻓崎的法海寺壁画展将于7月下旬开幕。 东京“中国文化中心”展览“北 
            京法海寺壁画展”于年底展出。 
            </p> 

            <img id="image-thing-m" src="M2.jpg" /> 

            <img id="image-thing-m" src="M3.jpg" /> 

            <br /> 

          </div>
        </>
    );
  }
  
  export default MagnificentMandarin; 